import { render, staticRenderFns } from "./leadLive.vue?vue&type=template&id=f1187962&"
import script from "./leadLive.vue?vue&type=script&lang=js&"
export * from "./leadLive.vue?vue&type=script&lang=js&"
import style0 from "./leadLive.vue?vue&type=style&index=0&id=f1187962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports